/** @jsxImportSource @emotion/react */
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { accessAPI, storeInLS, urlLogin } from "../../shared";
import { ProgressSpinner } from "primereact/progressspinner";

export default function Login() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Igual que el admin: el oauthtoken del state (navegación interna) o de la
    // URL (vuelta del portal público a "/?oauthtoken=…")
    const oauthtoken = state?.oauthtoken || searchParams.get("oauthtoken");

    if (oauthtoken) {
      accessAPI(
        "POST",
        "oauth/onetimesignon",
        { oauthtoken },
        (response) => {
          storeInLS(process.env.REACT_APP_LS_LOGIN_TOKEN, response.token);
          // Usar window.location para forzar recarga completa y asegurar que el token esté disponible
          window.location.href = "/";
        },
        (response) => {
          window.location.href = urlLogin();
        }
      );
    } else {
      window.location.href = urlLogin();
    }
  }, [state, navigate, searchParams]);

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5"
      }}
    >
      <ProgressSpinner
        css={{
          width: "50px",
          height: "50px"
        }}
      />
      <p
        css={{
          marginTop: "1.5rem",
          color: "#666",
          fontSize: "1rem"
        }}
      >
        Iniciando sesión...
      </p>
    </div>
  );
}
